var localeSpecificCart = {

  elements: {},
  root: '',

  init: function() {
    if(
      typeof Shopify == 'undefined' ||
      typeof Shopify.routes == 'undefined' ||
      typeof Shopify.routes.root == 'undefined'
    ) {
      return;
    }

    if(typeof BoosterTheme == 'undefined') {
      return;
    }

    if(!this.getElements()) {
      return;
    }

    this.root = Shopify.routes.root;

    if(this.root == '/') {
      this.showCartPageSection();

      return;
    }

    this.setEvents();
  },

  getElements: function() {
    this.elements.cartPageSection = jQuery('.section--cart-page');
    if(!this.elements.cartPageSection.length) {
      return false;
    }

    return true;
  },

  setEvents: function() {
    var _self = this;

    BoosterTheme.cart.events.on('booster:content:update', function() {
      _self.hideCartPageSection();
      _self.updateCartPageSection();
    });
  },

  hideCartPageSection: function() {
    this.elements.cartPageSection.addClass('hide');
  },

  showCartPageSection: function() {
    this.elements.cartPageSection.removeClass('hide');
  },

  updateCartPageSection: async function() {
    var markup = await (
      await fetch(
        this.root + '?section_id=cart-page',
        {
          headers: {
            Pragma: "no-cache",
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Expires: 0
          }
        }
      )
    ).text();

    var section = jQuery(markup);

    var sectionContent = section.children();

    this.updateCartPageSectionContent(sectionContent);
    this.showCartPageSection();
  },

  updateCartPageSectionContent: function(sectionContent) {
    this.elements.cartPageSection.empty();
    this.elements.cartPageSection.append(sectionContent);
    BoosterTheme.lazy.update();
  }

};

function initLocaleSpecificCart() {
  if(typeof BoosterTheme == 'undefined') {
    setTimeout(initLocaleSpecificCart, 200);

    return;
  }

  localeSpecificCart.init();
}

jQuery(document).ready(function() {
  initLocaleSpecificCart();
});
